import { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';
import { useGlassData } from './useGlassData';

const GlassThickness = ({ value, onChange, id='GlassThickness', label = 'Neat Glass', disabled = false, showPics = false }) => {
    const { getGlassThickness, loading } = useGlassData();
    const options = getGlassThickness();
    const defaultValue = options.length > 0 ? options[0].value : "3mm";
    const [selectedGlassThickness, setSelectedGlassThickness] = useState(value || defaultValue);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedGlassThickness(value || defaultValue);
    }, [value, defaultValue]);

    const handleGlassThicknessChange = (e) => {
        setSelectedGlassThickness(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled || loading}
                id={id}
                value={selectedGlassThickness}
                onChange={handleGlassThicknessChange}
            >
                {options.map(opt => (
                    <option key={opt.id} value={opt.value}>
                        {selectedGlassThickness === opt.value ? `${opt.label} ✔` : opt.label}
                    </option>
                ))}
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/GlassThickness"
                imageName={selectedGlassThickness}
                width={200}
                height={250}
            />
        </div>
    );
};

export default GlassThickness;
